<template class="main">
  <div class="main-dev">
    <Banner image="guitarra-2" />
      <v-container class="header-container">
        <v-row class="header">
          <v-col cols="12" xs="12" sm="12" md="5" lg="5" class="header-option">
            <v-col cols="auto" class="header-info animated fadeInLeft delay-1s" :class="getRandomColor">
            <span class="header-info__category font-weight-light body-2">{{post.category.name}}</span>
            <h2 class="header-info__title display-1 font-weight-bold mb-2">{{post.title}}</h2>
            <span class="header-info__date body-2 mb-3 grey--text text--darken-1">{{post.date | momentDate}}</span>
            <p class="">{{post.description}}</p>
            <p class="header-info__author title">Genaro Pretill</p>
            <div class="fb-share-button" 
              :data-href="urlShare" 
              data-layout="button_count">
            </div>
          </v-col>
          </v-col>
          <v-col class="header-img" cols="11" xs="11" sm="11" md="6" lg="6">
            <img class="animated zoomIn delay-1s" :src="post.imageURL" alt="">
          </v-col>
        </v-row>
      </v-container>
    <div style="background:#fff;">
      <v-container>
        <v-row>
        <v-col class="redes" cols="auto" xs="12" sm="12" md="1" lg="1">
          <aside-redes></aside-redes>
        </v-col>
        <v-col  class="main-content" cols="auto"  xs="12" sm="12" md="8" lg="8">
          <div v-html="post.content">
          </div>
          <div class="content-adicional" v-if="post.link !== ''">
            <p>Enlace adicional: <a :href="post.link" target="_black">Link</a></p>
          </div>
        </v-col>
        <v-col class="pr-0 aside-top" cols="auto"  xs="12" sm="12" md="3" lg="3">
          <section-lateral />
        </v-col>
        <v-col cols="auto" class="comentarios"  xs="12" sm="12" md="12" lg="12">
          <v-col cols="12" xs="12" sm="12" md="6" lg="6" >
            <div class="fb-comments" :data-href="urlShare" data-width="" data-numposts="5"></div>
          </v-col>
        </v-col>
      </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/BannerBlog';
import SectionLateral from '@/components/SectionLateral';
import AsideRedes from '@/components/AsideRedes';
const moment = require('moment');
  export default {
    name:'blog',
    components:{Banner,SectionLateral,AsideRedes},
    created(){
      this.obtenerDatos(),
      (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v3.0";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'))
    },
    data(){
      return{
        id:this.$route.params.id,
        post:{}
      }
    },
    methods:{
      async obtenerDatos(){
        await this.axios.get(`${this.$store.state.baseURL}/api/blogs/`+ this.id,{
          headers: { token: localStorage.getItem('token')}
          })
          .then(res => {
            const resultado = res.data 
            this.post = resultado
          })
      },
    },
    computed:{
      urlShare(){
        let urlName=`${window.location.origin}/blog/`
        let urlId= this.$route.params.id
        return urlName+urlId
      },
      getRandomColor(){
          const colors = ['color1', 'color2', 'color3','color4','color5','color6','color7','color8','color9','color10','color11','color12']
          // Conseguimos un índice de forma aleatoria dentro de los límites del arreglo
          let randomColor = Math.round(Math.random() * (colors.length - 1))
          // Obtenemos un color aleatorio
          return colors[randomColor]
      }
    },
    filters:{
      momentDate: function (value) {
        moment.locale('es');
        return moment(value).format('ll')
      }
    }
  }
</script>

<style lang="scss" scoped>
.header-option{
  padding: 0;
  @media screen and (max-width:900px){ 
    padding-left: 1rem;
    height: auto;
  }
}
.aside-top{
  width: 100%;
  @media screen and (max-width:900px){ 
    padding: 0;
    order:3;
  }
}
.redes{
  @media screen and (max-width:900px){ 
    width: 100%;
  }
}
.comentarios{
  @media screen and (max-width:900px){ 
    order:2;
  }
}
.col{
  @media screen and (max-width:900px){ 
    margin-left:1rem;
  }
}
.header{
  height:340px;
  justify-content: space-between;
  @media screen and (max-width:900px){ 
    height:auto;
  }
  &-container{
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  &-info{
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 2.5rem;
    @media screen and (max-width:900px){ 
    margin: 0;
    }
    &::before{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 10px;
    height: 100%;
    border-radius: 5px;
    background-color: #8C634A;
    }
    &__title{
    @media screen and (max-width:600px){ 
      font-size: 24px !important;
    }
    }
    &__category{
      color:  #8C634A;
      text-transform: uppercase;
    }
  }
  &-img{
    position: relative;
    @media screen and (max-width:900px){ 
      width: 100%;
      height: 0;
      overflow: hidden;
      margin-left: 1rem;
      margin-top: 1rem;
      padding-bottom: 56.25%;
    }
    & img{
    border-radius: 10px;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
      @media screen and (max-width:900px){ 
        height: 80%;
        // position: static;
      }
      @media screen and (max-width:600px){ 
        height: 100%;
      }
    }
  }
}
.main-content{
  @media screen and (max-width:900px){ 
    padding: 12px 1rem;
  }
}
.content-adicional{
  position: relative;
  &::Before{
    content:'';
    position: absolute;
    width: 50%;
    height: 1px;
    border-radius: 5px;
    background-color: #8C634A;
  }
  & p {
    margin-bottom: 0;
    margin-top: 2rem;
    padding-top: .5rem;
    color:#616161;
    & a{
      text-decoration: none;
      color:#2F1640;
      &:hover{
        text-decoration:underline;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.color1{
  &::before{
    content:'';
    background:#8C634A;
  }
}
.color2{
  &::before{
    content:'';
    background:#3498db;
  }
}
.color3{
  &::before{
    content:'';
    background:#2ecc71;
  }
}
.color4{
  &::before{
    content:'';
    background:#9b59b6;
  }
}
.color5{
  &::before{
    content:'';
    background:#34495e;
  }
}
.color6{
  &::before{
    content:'';
    background:#f1c40f;
  }
}
.color7{
  &::before{
    content:'';
    background:#e67e22;
  }
}
.color8{
  &::before{
    content:'';
    background:#e74c3c;
  }
}
.color9{
  &::before{
    content:'';
    background:#f39c12;
  }
}
.color10{
  &::before{
    content:'';
    background:#c0392b;
  }
}
.color11{
  &::before{
    content:'';
    background:#bdc3c7;
  }
}
.color12{
  &::before{
    content:'';
    background:#95a5a6;
  }
}
</style>